import type { TRenderedSocialItem } from 'shared/types/socials';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';
import { NBSP } from 'shared/constants/symbols';

interface ISocialsProps {
  items: TRenderedSocialItem[];
  device: TDeviceType;
}

export const Socials: React.FC<ISocialsProps> = ({ items, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>
        Циан для риелторов в{NBSP}соцсетях: советы по{NBSP}размещению, новости платформы, кейсы агентов
      </div>
      <div className={styles['socials']}>
        {items.map(({ Icon, url }) => (
          <a href={url} target="_blank" rel="noopener noreferrer" className={styles['social']} key={url}>
            <Icon />
          </a>
        ))}
      </div>
    </div>
  );
};
